import _ from 'underscore';
import View from 'view/base';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Survey_Question from 'model/survey_question';

var type_labels = {
    general: 'General',
    bug: 'Bug',
    feature_request: 'Idea',
};

var setting_field_labels = {
    rating_help_message:'Intro',
    rating_type:'Rating',
    name_field: 'Name',
    email_field: 'Email',
    display_category:'Category',
    display_priority:'Priority',
    display_assignee:'assignee',
    title_field: 'Title',
    comment_field: 'Description',
    allow_screenshot:'Screenshot',
    allow_video:'Video',
    allow_attachment:'Attachment',
    allow_session_recording:'Session Replay'
};

var Template_Sidebar = View.extend({
    className: 'template-preview-sidebar',

    template: null,
    total: 0,
    index: -1,

    events: {
        'click .nav-close'       : 'onClose',
        'click .use-template-btn': 'onUseTemplate',
        'click .account-upgrade' : 'onUpgradeAccount',
    },

    dom_handlers: {
        onClose: function() {
            this.trigger('template:close');
        },
        onUseTemplate: function() {
            this.trigger('template:use', this.template.template_code);
        },
        onUpgradeAccount: function(e) {
            Modals.choosePlan();
        },
    },

    setTemplate: function(template, options) {
        this.template = template;
        this.project_type = this.template.template_code.substring(0, 2) === 'su' ? 'survey' : 'feedback';
        this.total = options.total;
        this.index = options.index;

        this.render();
    },

    isNextGen: function() {
        return this.template.widget_version === 2;
    },

    render: function() {
        var content = '';

        if (this.template) {
            var groups_content = '';

            if (this.project_type === 'survey') {
                var questions = this.template.questions;
                var question_list_content = '';

                // exclude thank you page and sort by order
                questions = _.sortBy(_.filter(questions, (question) => question.question_type !== 'thankyou'), (question) => question.question_sort);

                questions.forEach((question) => {
                    var question_model = new Survey_Question();
                    question_model.set(question);
                    question_list_content += '<div class="feature-group-item flex-between" data-type="' + question_model.getQuestionCategory() + '">' +
                        '<span>' + question_model.getQuestionType() + '</span>' +
                    '</div>';
                });

                groups_content =
                '<div class="feature-group">' +
                    '<div class="feature-group-body">' +
                        question_list_content +
                    '</div>' +
                '</div>';
            }

            var section_content = '';
            if (this.project_type === 'feedback') {
                var bug_on, idea_on, general_on;

                if (this.isNextGen()) {
                    bug_on = this.template.feedback_type.indexOf('bug') !== -1;
                    idea_on = this.template.feedback_type.indexOf('feature_request') !== -1;
                    general_on = this.template.feedback_type.indexOf('general') !== -1;
                } else {
                    bug_on = this.template.workflow_type.indexOf('bug') !== -1;
                    idea_on = this.template.workflow_type.indexOf('feature_request') !== -1;
                    general_on = this.template.workflow_type.indexOf('general') !== -1;
                }

                section_content = '<div class="section-box">' +
                    '<div class="section-title">Highlights</div>' +
                    '<div class="section-body">' +
                        '<div class="box-neutral">' +
                            '<p>' + Util.htmlEntities(this.template.template_desc) + '</p>' +
                        '</div>' +
                        '<div class="divider-24"></div>' +
                        '<div class="feature-group">' +
                            '<div class="feature-group-heading">Feedback Types</div>' +
                            '<div class="feature-group-body">' +
                                (this.template.ai_feedback_type ?
                                '<div class="margin-top-12 font-weight-medium"><i class="fa-solid fa-sparkles text-icon"></i> AI Assisted</div>' +
                                '<div class="margin-top-4">AI is used to automatically classify user feedback as a bug, idea, or general feedback.</div>' +
                                '<div class="divider-4"></div>' : '') +
                                '<div class="feature-group-item">' +
                                    (bug_on ?
                                    '<i class="far fa-check"></i>' :
                                    '<i class="far fa-times text-danger"></i>') +
                                    '<span class="cap">Bug</span>' +
                                '</div>' +
                                '<div class="feature-group-item">' +
                                    (idea_on ?
                                    '<i class="far fa-check"></i>' :
                                    '<i class="far fa-times text-danger"></i>') +
                                    '<span class="cap">Idea</span>' +
                                '</div>' +
                                '<div class="feature-group-item">' +
                                    (general_on ?
                                    '<i class="far fa-check"></i>' :
                                    '<i class="far fa-times text-danger"></i>') +
                                    '<span class="cap">General</span>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';
            } else {
                var result_content = '';
                var thankyou = _.filter(this.template.questions, (question) => question.question_type === 'thankyou');

                if (thankyou.length) {
                    var thankyou_list_content = '';
                    thankyou.forEach((question) => {
                        var question_model = new Survey_Question();
                        question_model.set(question);
                        thankyou_list_content += '<div class="feature-group-item flex-between" data-type="' + question_model.getQuestionCategory() + '">' +
                            '<span>' + question_model.getQuestionType() + '</span>' +
                        '</div>';
                    });

                    result_content =
                        '<div class="section-title">Ends with</div>' +
                        '<div class="section-body">' +
                            '<div class="feature-group">' +
                                '<div class="feature-group-body">' +
                                    thankyou_list_content +
                                '</div>' +
                            '</div>' +
                        '</div>';
                }

                section_content = '<div class="section-box">' +
                    '<div class="section-title">Questions</div>' +
                    '<div class="section-body">' +
                        groups_content +
                    '</div>' +
                    result_content +
                '</div>';
            }

            content +=
                '<div class="template-preview-sidebar-header">' +
                    '<div class="region-nav">' +
                        '<button type="button" class="nav-close"><i class="fa-regular fa-xmark"></i></button>' +
                    '</div>' +
                    '<div class="region-heading">' +
                        '<div class="template-title">Template</div>' +
                        '<div class="template-name">' + this.template.template_name + '</div>' +
                    '</div>' +
                    '<div class="region-btn">' +
                        '<button type="button" class="primary medium fluid use-template-btn" data-theme="' + this.project_type + '">Use this template</button>' +
                    '</div>' +
                '</div>' +
                '<div class="template-preview-sidebar-body" data-project-type="' + this.project_type + '">' + section_content + '</div>';
        }

        this.$el.html(content);

        return this;
    },
});

export default Template_Sidebar;
